import type { CanvasResourceDropPayload } from '@/features/preview/canvasDropZones'
import type MainProject from '@/model/MainProject'
import AvgButton from '@/model/ComControl/AvgButton'
import FileName from '@/model/ComControl/FileName'

/**
 * 将资源管理器拖入 payload 转为图片选项（btnList）使用的相对路径（基于 `图片/button`）。
 */
export function resolveButtonOptionStoredPath(payload: CanvasResourceDropPayload): string {
  const segments = payload.folderPath.split('/').filter(Boolean)
  if (segments[0] === '按钮') {
    segments.shift()
  }
  const prefix = segments.join('/')
  const file = payload.relativePath.trim()
  if (!file) return ''
  return prefix ? `${prefix}/${file}` : file
}

/**
 * 在工程 btnList 中查找或追加与拖拽图片对应的按钮索引。
 * @returns 按钮索引；btnList 缺失时返回 null
 */
export function ensureBtnListIndexForDroppedGraphic(
  project: MainProject,
  storedPath: string,
  displayName: string,
): number | null {
  const btnList = project.systemData?.btnList
  if (!btnList) {
    console.error('[canvas-drop] systemData.btnList 不存在，无法绑定图片选项按钮')
    return null
  }
  const normalizedPath = storedPath.trim()
  if (!normalizedPath) return null
  const buttons = btnList.buttons
  for (let index = 0; index < buttons.length; index += 1) {
    const current = String(buttons[index]?.NoneImage?.name ?? '').trim()
    if (current === normalizedPath) return index
  }
  const button = new AvgButton()
  const label = displayName.trim() || normalizedPath.split('/').pop() || '按钮'
  button.Name = label.replace(/\.[^./\\]+$/, '') || label
  button.NoneImage = new FileName({ type: FileName.DEF_TYPE, name: normalizedPath })
  button.MoveImage = new FileName({ type: FileName.DEF_TYPE, name: '' })
  const nextIndex = buttons.length
  buttons.push(button)
  return nextIndex
}

/** 格式化为 `ButtonDif.ButtonChoice` 单项：`按钮index,x,y`。 */
export function formatButtonChoiceEntry(buttonIndex: number, x: number, y: number): string {
  return `${buttonIndex},${Math.round(x)},${Math.round(y)}`
}
